"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var styles_1 = require("../../../styles");
var padding = '7px 16px';
exports.TextArea = styled_1.default.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  height: 112px;\n  line-height: 1.5;\n"], ["\n  ", "\n  ", "\n  height: 112px;\n  line-height: 1.5;\n"])), function (_a) {
    var error = _a.error;
    return (0, styles_1.MixinInputBaseStyle)({ error: error, padding: padding });
}, (0, styles_1.MixinPlaceholderStyle)());
var templateObject_1;
